const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { formatText } = require('core/i18n').i18n;
const { cloneDeep, isObject, map, set, get, find } = require('lodash');

// @ commons
const { InputSafe } = require('commonsComponents/inputSafe');

// @ constants
const { showErrorCeaCode } = require('./initialValues');
const ACTUAL_YEAR = new Date().getFullYear();

class CeaCode extends React.Component {
    constructor(props) {
        super(props);
        this.values = props.values;
        this.inputs = {
            ceaCode: {},
            idCea: '',
            dateGenCea: {}
        };
        this.showError = cloneDeep(showErrorCeaCode);
        this.inputErrorText = props.inputErrorText;

        this.handleOnChange = this.handleOnChange.bind(this);
    }

    ceaCodeInputs(codes) {
        return map(codes, (value, idx) => (
            <div className="col-md-2" key={idx}>
                {this.input(`ceaCode.${idx}`, value, 5)}
            </div>
        ));
    }

    handleOnChange(el) {
        const { name, value } = el.target;

        if (!value.match(/^[0-9a-zA-Z]*$/)) { // sólo se permiten alfanúmeros en los inputs
            return false;
        }

        if (name.match(/^ceaCode\.[1-6]$/)) { // si es algún input del codigo de 25 caracterees
            const id = parseInt(name.replace('ceaCode.', ''), 10);
            this.values.inputsCode[id] = value;
            /**
             * si el input es 1 de las 5 casillas, validar que ya escribió 5 digitos para pasar al siguiente input
             *
             */
            value.length === 5 && id < 6 && this.inputs.ceaCode[id + 1].el.focus();

        } else if (name.match(/^idCea$/)) { // si es el id
            this.values.idCea = value;
            /**
             * validar que ya escribió 12 digitos para pasar al siguiente input
             */
            value.length === 12 && this.inputs.dateGenCea.day.el.focus();

        } else if (name.match(/^dateGenCea.[a-z]+$/)) { // si es la fecha
            if (!value.match(/^[0-9]*$/)) {
                return false;
            }

            if (name === 'dateGenCea.day') { // validar que está en el input de fecha y que ya escribió 4 digitos para pasar al siguiente input
                if (parseInt(value, 10) > 31) { // máximo 31 dias
                    return false;
                }
                this.values.dateGenCea.day = value;
                value.length === 2 && this.inputs.dateGenCea.month.el.focus();

            } else if (name === 'dateGenCea.month') { // validar que está en el input de fecha y que ya escribió 4 digitos para pasar al siguiente input
                if (parseInt(value, 10) > 12) { // máximo 12 meses
                    return false;
                }
                this.values.dateGenCea.month = value;
                value.length === 2 && this.inputs.dateGenCea.year.el.focus();

            } else if (name === 'dateGenCea.year') { // validar que está en el input de fecha y que ya escribió 4 digitos para pasar al siguiente input
                if (parseInt(value, 10) > ACTUAL_YEAR) {
                    return false;
                }
                this.values.dateGenCea.year = value;
                value.length === 4 && this.inputs.ceaCode['1'].el.focus();
            }
        }

        this.forceUpdate();
    }

    input(name, value, maxLength, placeholder = '') {
        return (
            <div>
                <InputSafe
                    type="text"
                    maxLength={maxLength}
                    name={name}
                    value={value}
                    placeholder={placeholder}
                    onChange={this.handleOnChange}
                    ref={input => set(this.inputs, name, input)}
                    key={name}
                    disabled={this.props.disable}
                    errorState={!this.props.disable && get(this.showError, name)}
                    errorMessage={this.inputErrorText}
                />
            </div>
        );
    }

    shouldValidate() {
        const dateNotEmpty = find(this.values.dateGenCea, dateValue => dateValue !== '');
        const codeNotEmpty = find(this.values.inputsCode, codeValue => codeValue !== '');

        return !!this.values.idCea || !!dateNotEmpty || !!codeNotEmpty;
    }

    updateValues(newValues) {
        this.values = newValues;
    }

    validateInputsData() {
        let errr = false;
        this.showError = cloneDeep(showErrorCeaCode);

        if (this.shouldValidate()) {
            this.showError.idCea = this.values.idCea.length !== 12;

            this.showError.dateGenCea = {
                day: this.values.dateGenCea.day.length !== 2,
                month: this.values.dateGenCea.month.length !== 2,
                year: this.values.dateGenCea.year.length !== 4
            };

            map(this.values.inputsCode, (value, idx) => this.showError.ceaCode[idx] = this.values.inputsCode[idx].length !== 5);

            map(this.showError, error => {
                if (isObject(error)) {
                    map(error, _error => {
                        if (_error) {
                            errr = _error;
                            return false;
                        }
                    });
                } else {
                    if (error) {
                        errr = error;
                    }
                }
            });
        }

        return errr ? false : this.values;
    }

    render() {
        const values = this.values;

        return (
            <div>
                <h6>{formatText('mortgageRequestWorkData-workCEACodeTitle')}</h6>
                <p>{formatText('mortgageRequestWorkData-workCEACodeDescription')}</p>
                <p>{formatText('mortgageRequestWorkData-workCEACodeDescription2')}</p>

                <div className="row separator">
                    <div className="col-md-5">
                        <label>{formatText('mortgageRequestWorkData-workCEACodeIdCEA')}</label>
                        {this.input('idCea', values.idCea, 12)}
                    </div>

                    <div className="col-md-7">
                        <label>{formatText('mortgageRequestWorkData-workCEACodeDate')}</label>
                        <div className="row">
                            <div className="col-md-4  md-form-group">
                                {this.input('dateGenCea.day', values.dateGenCea.day, 2, formatText('mortgageRequestCommons-dayText').toLowerCase())}
                            </div>
                            <div className="col-md-4  md-form-group">
                                {this.input('dateGenCea.month', values.dateGenCea.month, 2, formatText('mortgageRequestCommons-monthText').toLowerCase())}
                            </div>
                            <div className="col-md-4  md-form-group">
                                {this.input('dateGenCea.year', values.dateGenCea.year, 4, formatText('mortgageRequestCommons-yearText').toLowerCase())}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row separator">
                    <div className="col-md-12">
                        <label>{formatText('mortgageRequestWorkData-workCEACodeCode')}</label>
                        <div className="row">
                            {this.ceaCodeInputs(values.inputsCode)}
                        </div>
                    </div>
                </div>
            </div>

        );
    }

}

CeaCode.propTypes = {
    disable: PropTypes.bool,
    values: PropTypes.object,
    inputErrorText: PropTypes.string
};

module.exports = CeaCode;
